module.exports = __webpack_public_path__ + "static/media/06.ccfe1f22.jpg";